module.exports = __webpack_public_path__ + "static/img/logo.08c4541.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.png
// module id = iQH9
// module chunks = 1